module.exports = __webpack_public_path__ + "img/1-title.12c94678.png";